import config, { LOCAL_STORAGE_PREFIX } from "./app.constants";
import OAuth2Service, { LocalStorageKey } from "app/services/OAuth2.service";

const defaultHeaders = () => {
  const option = {
    "X-NBI-Source": "CONNECT",
    "X-NBI-CorrelationId": `${config.generateUuidv4()}`,
    "Content-Type": "application/json",
  };
  if (config.enableOAuth2) {
    const token = OAuth2Service.getOAuth2AccessTokenForHeader();
    return {
      ...option,
      Authorization: `Bearer ${token}`,
    };
  }
  return option;
};

export const headers = {
  defaultHeaders,
  backendApiKeyHeader: { "X-API-KEY": `${config.iPosServiceApiKey}` },
  appVersion: `${config.VERSION_SHORT}`,
};
